import { IScopeAccuracyStats } from "@/api";
import { Paper, useMediaQuery, useTheme } from "@mui/material";
import { LineChart } from "@mui/x-charts";
import { formatInTimeZone } from "date-fns-tz";

interface IProps {
    scopeAccuracy: IScopeAccuracyStats[];
}

export const ScopeAccuracy = ({ scopeAccuracy }: IProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

    const lastSixMonths = scopeAccuracy.slice(-6);

    const dataset = lastSixMonths.map((item) => ({
        percent: item.accuracy * 100,
        date: formatInTimeZone(item.date, "UTC", "MMMM"),
    }));

    function valueFormatter(value: number | null) {
        if (!value) return "N/A";

        return `${value}%`;
    }

    return (
        <Paper variant="outlined" sx={{ height: "100%", width: "100%", p: 1 }}>
            <LineChart
                dataset={dataset}
                series={[
                    {
                        dataKey: "percent",
                        label: "Scope Accuracy Over Time",
                        color: theme.palette.primary.main,
                        baseline: 0,
                        valueFormatter,
                    },
                ]}
                xAxis={[{ scaleType: "point", dataKey: "date" }]}
                yAxis={[{ min: 0, max: 100 }]}
                slotProps={{
                    tooltip: { trigger: "item" },
                }}
                height={isMobile ? 350 : 450}
            />
        </Paper>
    );
};
